<template>
  <v-container>
    <!-- DIALOG ADD CD start -->  
    <v-dialog transition="fade-transition" v-model="dialogAddCd" persistent style="position:relative">
      <v-card class="pa-5">
        <div v-show="!isUpLoaded" class="uploading-block"> 
          <div class="loader"></div>
          <div class="progress ma-4 font-weight-bold white--text">{{uploadProgress.toFixed()+"%"}}</div>
        </div>
        <v-card-text>
          <v-form
            ref="formAddCd"
            v-model="validFormAddCd" 
          >
            <v-tabs
              background-color="#ab4538"
              dark
              centered
            >
              <v-tab>Basic Info</v-tab>
              <v-tab>Tracks</v-tab>
              <v-tab-item class="pt-10">
                
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <v-row no-gutters>
                      <v-col cols="10">
                        
                        <v-file-input
                          :disabled="!validFormAddCd || uploadArtworkReady || Object.keys(newCd.artwork).length > 0"
                          ref="inputFileArtwork"
                          label="Cd Artwork"
                          prepend-icon="mdi-file-image"
                          accept="image/*"
                          show-size
                          @change="onFilePickedArtwork($event)"
                        ></v-file-input>
                      
                      </v-col>
                      <v-col cols="2" class="d-flex align-center justify-center">

                        <v-btn
                          v-if="Object.keys(newCd.artwork).length === 0"
                          :disabled="!validFormAddCd || !uploadArtworkReady"
                          @click="uploadFileArtwork()"
                          icon
                          color="primary"
                        >
                          <v-icon>mdi-upload-outline</v-icon>
                        </v-btn>
                         <v-btn
                          v-else
                          @click="removeFileArtwork()"
                          icon
                          color="red"
                        >                        
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>   

                      </v-col>
                      <v-col cols="10">

                        <v-file-input
                          :disabled="!validFormAddCd || uploadTranscriptReady || Object.keys(newCd.transcript).length > 0"
                          ref="inputFileTranscript"
                          label="Transcript"
                          prepend-icon="mdi-pdf-box"
                          accept=".pdf"
                          show-size
                          @change="onFilePickedTranscript($event)"
                        ></v-file-input>
                      
                      </v-col>
                      <v-col cols="2" class="d-flex align-center justify-center">

                        <v-btn 
                          v-if="Object.keys(newCd.transcript).length === 0"
                          :disabled="!validFormAddCd || !uploadTranscriptReady"
                          @click="uploadFileTranscript()"
                          icon
                          color="primary"
                        >
                          <v-icon>mdi-upload-outline</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          @click="removeFileTranscript()"
                          icon
                          color="red"
                        >                        
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>                           

                      </v-col>
                      <v-col cols="10">

                        <v-file-input
                          :disabled="!validFormAddCd || uploadZipReady || Object.keys(newCd.zip).length > 0"        
                          ref="inputFileZip"
                          label="Cd Zipped"
                          prepend-icon="mdi-folder-zip"
                          accept=".zip,.rar"
                          show-size
                          @change="onFilePickedZip($event)"
                        ></v-file-input>

                      </v-col>
                      <v-col cols="2" class="d-flex align-center justify-center">

                        <v-btn
                          v-if="Object.keys(newCd.zip).length === 0"
                          :disabled="!validFormAddCd || !uploadZipReady"
                          @click="uploadFileZip()"
                          icon
                          color="primary"
                        >                        
                          <v-icon>mdi-upload-outline</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          @click="removeFileZip()"
                          icon
                          color="red"
                        >                        
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>                        

                      </v-col>
                      <v-col cols="12">
                        <div class="pt-5 d-flex justify-center">
                          <div class="py-1 px-8 grey lighten-3" style="border-radius:10px">
                            <v-switch
                              v-model="newCd.published"
                              label="Published"
                            ></v-switch>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>                     
                  <v-col cols="12" md="8">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        
                        <v-text-field 
                          v-model="newCd.title"
                          label="CD Title*"
                          :rules="cdTitleRules"
                          prepend-icon="mdi-database"
                          required
                        ></v-text-field>

                      </v-col>
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="newCd.teacher"
                          label="Teacher"
                          prepend-icon="mdi-school"
                        ></v-text-field>     

                      </v-col>                      
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="newCd.year"
                          label="Cd Year (ex. 2020 A)"
                          prepend-icon="mdi-calendar-clock"
                        ></v-text-field>                        
                      
                      </v-col>
                      <v-col cols="12" md="6">

                        <v-menu
                          ref="cdReleaseDateMenuAdd"
                          v-model="cdReleaseDateMenuAdd"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="290px"
                          :nudge-top="20"
                          :nudge-right="33"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="newCd.release_date"
                              label="Release Date"
                              prepend-icon="mdi-calendar-arrow-right"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newCd.release_date"
                            no-title
                            scrollable
                            @input="cdReleaseDateMenuAdd = false"
                          ></v-date-picker>
                        </v-menu>

                      </v-col>
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="newCd.buy_url"
                          label="Buy Url"
                          prepend-icon="mdi-cart"
                        ></v-text-field>

                      </v-col>
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="newCd.soundcloud_url"
                          label="SoundCloud Url"
                          prepend-icon="mdi-soundcloud"
                        ></v-text-field>

                      </v-col>
                      <v-col cols="12">
                      
                        <div class="py-4">
                          <ckeditor 
                            :editor="editor" 
                            v-model="newCd.description" 
                            :config="editorConfig"
                          ></ckeditor>
                        </div>

                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

              </v-tab-item>
              <v-tab-item class="pt-10">
                <h1>TRACKS</h1>

                <v-row no-gutters>
                  <v-col cols="10">
                                               
                    <v-file-input
                      :disabled="!validFormAddCd || uploadTracksReady || Object.keys(newCd.tracks).length > 0" 
                      ref="inputFileTracks"
                      label="All Tracks"
                      prepend-icon="mdi-database"
                      accept=".mp3"
                      show-size
                      multiple
                      @change="onFilePickedTracks($event)"
                    ></v-file-input>

                  </v-col>
                  <v-col cols="2" class="d-flex align-center justify-center">

                      <v-btn
                        v-if="Object.keys(newCd.tracks).length === 0"
                        :disabled="!validFormAddCd || !uploadTracksReady"
                        @click="uploadFilesTracks()"
                        icon
                        color="primary"
                      >                        
                        <v-icon>mdi-upload-outline</v-icon>
                      </v-btn>

                    </v-col>
                </v-row>

              </v-tab-item>                    
            </v-tabs>
          </v-form>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn dark @click.stop="unSetDialogAddCd">
            <v-icon>mdi-close-circle</v-icon>
            <span>Close</span>
          </v-btn>

          <v-btn color="primary" class="mr-4" :disabled="!validFormAddCd" @click.stop="addCd">
            <v-icon>mdi-database-plus</v-icon>
            <span>Add Cd</span>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG ADD CD end -->  

    <!-- DIALOG UPDATE CD start -->  
    <v-dialog transition="fade-transition" v-model="dialogUpdateCd" persistent>
      <v-card class="pa-5">
        <v-card-text>
          <v-form
            ref="formUpdateCd"
            v-model="validFormUpdateCd" 
          >
            <v-tabs
              background-color="#ab4538"
              dark
              centered
            >
              <v-tab>Basic Info</v-tab>
              <v-tab>Tracks</v-tab>
              <v-tab-item class="pt-10">
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <v-row no-gutters>
                      <v-col cols="12">



                      </v-col>
                      <v-col cols="12">

          
                        
                      </v-col>
                      <v-col cols="12">

                   
                      </v-col>
                      <v-col cols="12">

                        <div class="pt-5 d-flex justify-center">
                          <div class="py-1 px-8 grey lighten-3" style="border-radius:10px">
                            <v-switch
                              v-model="selectedCd.published"
                              label="Published"
                            ></v-switch>
                          </div>
                        </div>
                      
                      </v-col>                      
                    </v-row>
                  </v-col>                   
                  <v-col cols="12" md="8">
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                                    
                        <v-text-field 
                          v-model="selectedCd.title"
                          label="Cd Title*"
                          prepend-icon="mdi-database"
                          :rules="cdTitleRules"
                          required
                        ></v-text-field>                        

                      </v-col>
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="selectedCd.teacher"
                          label="Teacher"
                          prepend-icon="mdi-school"
                        ></v-text-field>    

                      </v-col>                      
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="selectedCd.year"
                          label="Cd Year (ex. 2020 A)"
                          prepend-icon="mdi-calendar-clock"
                        ></v-text-field>              
                      
                      </v-col>
                      <v-col cols="12" md="6">

                        <v-menu
                          ref="cdReleaseDateMenuUpdate"
                          v-model="cdReleaseDateMenuUpdate"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          min-width="290px"
                          :nudge-top="20"
                          :nudge-right="33"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="selectedCd.release_date"
                              label="Release Date"
                              prepend-icon="mdi-calendar-arrow-right"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="selectedCd.release_date"
                            no-title
                            scrollable
                            @input="cdReleaseDateMenuUpdate = false"
                          ></v-date-picker>
                        </v-menu>

                      </v-col>
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="selectedCd.buy_url"
                          label="Buy Url"
                          prepend-icon="mdi-cart"
                        ></v-text-field>

                      </v-col>
                      <v-col cols="12" md="6">

                        <v-text-field 
                          v-model="selectedCd.soundcloud_url"
                          label="SoundCloud Url"
                          prepend-icon="mdi-soundcloud"
                        ></v-text-field>

                      </v-col>
                      <v-col cols="12">
                      
                        <div class="py-4">
                          <ckeditor 
                            :editor="editor" 
                            v-model="selectedCd.description" 
                            :config="editorConfig"
                          ></ckeditor>
                        </div>

                      </v-col>                      
                    </v-row>
                  </v-col>                 
                </v-row>

              </v-tab-item>
              <v-tab-item class="pt-10">
                
                <v-list class="mb-10">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(track, index) in selectedCd.tracks"
                      :key="index"
                    >
                      <v-list-item-avatar grey>
                        {{ ('0' + (index + 1) ).slice(-2) }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title><strong>{{ track.title }}</strong></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>

              </v-tab-item>                    
            </v-tabs>
          </v-form>           
        </v-card-text>
        <v-card-actions>

          <v-btn dark color="red" class="ml-4" @click.stop="deleteCd(selectedCd.id, selectedCd._storage_folder)">
            <v-icon>mdi-delete</v-icon>
            <span>Delete Cd</span>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn dark color="primary" class="mr-4" :disabled="!validFormUpdateCd" @click.stop="updateCd(selectedCd)">
            <v-icon>mdi-database-sync</v-icon>
            <span>Update Cd</span>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG UPDATE EVENT end -->  

    <div class="blockquote px-3 mb-6">
      <p>For many years and four times a year a Meditatio CD has been sent to each registered Christian Meditation group around the world.</p>
      <p>Below are the audio files (with transcripts) of these talks which have come from many different teachers in the community, including John Main and Laurence Freeman.</p>
      <p>To keep up with the times, these Meditatio CDs are being offered  as audio files that can be simply downloaded and used at weekly groups.</p>
      <p>A simple tutorial (<a title="how to find and download the audio files" href="http://tiny.cc/medtonl" target="_blank">see here</a>) shows you how to find and download the audio files.</p>
    </div>

    <div v-if="isAuthenticated" class="mb-10 text-right">
      <v-btn dark color="#ab4538" @click.stop="setDialogAddCd">
        <v-icon>mdi-database-plus</v-icon>
        <span>New Cd</span>
      </v-btn>
    </div>

    <v-list class="mb-10" :class="{ 'admin-view': isAuthenticated }">
      <v-list-item-group>
        <v-list-item
          two-line
          v-for="cd in cds"
          :key="cd.id"
          :to="'/cd/'+cd.id"
          :class="`cd-published-${cd.published}`"
        >
          <v-list-item-avatar>
            <v-img :src="cd.artwork.url"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title><strong>{{ cd.title }}</strong></v-list-item-title>
            <v-list-item-subtitle>
              <p>by <strong>{{ cd.teacher }}</strong>, {{ cd.year }}</p>
              <!-- <p><strong>Release date</strong> {{ cd.release_date | moment("D MMMM YYYY") }}</p> -->
            </v-list-item-subtitle>
          </v-list-item-content>
          
          <v-list-item-action>
            <div>
              <v-btn icon>
                <v-icon color="black">mdi-chevron-right</v-icon>
              </v-btn>
              <v-tooltip v-if="isAuthenticated" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn color="#ab4538" icon v-on="on" @click.prevent="setDialogUpdateCd(cd)">
                    <v-icon>mdi-database-edit</v-icon>
                  </v-btn>                  
                </template>
                <span>Edit Cd</span>
              </v-tooltip>   
            </div>
          </v-list-item-action>
          
        </v-list-item>
      </v-list-item-group>
    </v-list>

  </v-container>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { db } from '@/firebase/'
import { storage } from '@/firebase/'

export default {
  name: 'home',
  data() {
      return {
        cds: [],
        editor: ClassicEditor,
        editorConfig: {
          link: { addTargetToExternalLinks: true },
          placeholder: 'Add description for your Cd.',
          toolbar: [ 'bold', 'italic', 'bulletedList', 'numberedList', '|', 'link' ]
        }, 
        cdReleaseDateMenuAdd: false, 
        cdReleaseDateMenuUpdate: false,    
        validFormAddCd: false,
        validFormUpdateCd: false,
        cdTitleRules: [
            v => !!v || 'CD Title is required'
        ],
        currentlyEditing: null,
        newCd: {
          _storage_folder: '',
          published: false,
          title: '',
          title_slug: '',
          artwork: {},
          transcript: {},
          zip: {},
          year: '',
          release_date: '',
          teacher: '',
          description: '',
          buy_url: '',
          soundcloud_url: '',
          tracks: []
        },
        selectedCd: {},                  
        dialogAddCd: false,
        dialogUpdateCd: false,

        isUpLoaded: true,
        uploadProgress: 0,
        
        uploadArtwork: {},
        uploadArtworkReady: false,
        uploadTranscript: {},
        uploadTranscriptReady: false,
        uploadZip: {},
        uploadZipReady: false,
        
        uploadTracks: [],
        uploadTracksReady: false                       
      }
    },
    metaInfo() {
      return { 
          title: 'Meditatio Talks Series'
      }
    },    
    mounted() {
      this.getCdsData()
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }      
    },
    methods: {
      async getCdsData () {
        const cds = []
        let cdsData = await db.collection('meditatiotalks').orderBy('release_date', 'desc').get()
        cdsData.forEach(doc => {
          let appData = doc.data()
          appData.id = doc.id
          cds.push(appData)
        })
        this.cds = cds 
      },     
      setDialogAddCd() {
        this.clearFormAddCd()
        this.newCd._storage_folder =  'mt-' + Math.random().toString(36).substr(2, 9);
        this.dialogAddCd = true
      },  
      unSetDialogAddCd () {
        this.$refs.formAddCd.resetValidation()
        this.clearFormAddCd()
        this.dialogAddCd = false
      },
      clearFormAddCd(){
        this.newCd = {
          _storage_folder: '',
          published: false,
          title: '',
          title_slug: '',
          artwork: {},
          transcript: {},
          zip: {},
          year: '',
          release_date: '',
          teacher: '',
          description: '',
          buy_url: '',
          soundcloud_url: '',
          tracks: []
        },
        this.uploadArtwork = {},
        this.uploadArtworkReady = false,
        this.uploadTranscript = {},
        this.uploadTranscriptReady = false,
        this.uploadZip = {},
        this.uploadZipReady = false,
        this.uploadTracks = [],
        this.uploadTracksReady = false  
      },
      setDialogUpdateCd(cd) {
        this.selectedCd = cd
        this.currentlyEditing = cd.id
        this.dialogUpdateCd = true
      },
      unSetDialogUpdateCd() {
        this.currentlyEditing = null
        this.clearFormUpdateCd()
        this.dialogUpdateCd = false
      },
      clearFormUpdateCd(){
        this.selectedCd = {
          _storage_folder: '',
          published: '',
          title: '',
          title_slug: '',
          artwork: {},
          transcript: {},
          zip: {},
          year: '',
          release_date: '',
          teacher: '',
          description: '',
          buy_url: '',
          soundcloud_url: '',
          tracks: [],
          id: ''
        }
      },  
      async addCd () {
        if (this.$refs.formAddCd.validate()) {
          await db.collection('meditatiotalks').add({
          _storage_folder: this.newCd._storage_folder,
          published: this.newCd.published,
          title: this.newCd.title,
          title_slug: this.slugify(this.newCd.title),
          artwork: this.newCd.artwork,
          transcript: this.newCd.transcript,
          zip: this.newCd.zip,
          year: this.newCd.year,
          release_date: this.newCd.release_date,
          teacher: this.newCd.teacher,
          description: this.newCd.description,
          buy_url: this.newCd.buy_url,
          soundcloud_url: this.newCd.soundcloud_url,
          tracks: this.newCd.tracks.sort((a, b) => parseFloat(a.fileName) - parseFloat(b.fileName))
        })
          this.getCdsData(),        
          this.unSetDialogAddCd()               
        }
      },
      async updateCd (cd) {
        if (this.$refs.formUpdateCd.validate()) {
          await db.collection('meditatiotalks').doc(this.currentlyEditing).update({
            _storage_folder: cd._storage_folder,
            published: cd.published,
            title: cd.title,
            title_slug: this.slugify(cd.title),
            artwork: cd.artwork,
            transcript: cd.transcript,
            zip: cd.zip,
            year: cd.year,
            release_date: cd.release_date,
            teacher: cd.teacher,
            description: cd.description,
            buy_url: cd.buy_url,
            soundcloud_url: cd.soundcloud_url,
            tracks: cd.tracks
          })
          this.getCdsData(),
          this.unSetDialogUpdateCd()      
        }
      },
      // DELETE CD FROM DB
      async deleteCd(cdId, storagepPath) {
        await db.collection('meditatiotalks').doc(cdId).delete()
        this.deleteStorageFolder(storagepPath)
        this.dialogUpdateCd = false
        this.getCdsData()
      },
      // DELETE CD FROM STORAGE 
      deleteStorageFolder: function(path) {
        const folder = storage.ref().child(path)
        folder.listAll()
          .then(dir => {
            dir.items.forEach(fileRef => {
              this.deleteStorageFile(folder.fullPath, fileRef.name);
            });
            dir.prefixes.forEach(folderRef => {
              this.deleteStorageFolder(folderRef.fullPath);
            })
          })
          .catch(error => {
            window.console.log(error);
          });
      },
      deleteStorageFile: function(path, fileName) {
        const deleteFileTask = storage.ref().child(path+'/'+fileName)
        deleteFileTask.delete()
      }, 
      // UPLOAD-REMOVE ARTWORK
      onFilePickedArtwork(e) {
        if (e !== undefined) {
          this.uploadArtwork = {
            'name': e.name,
            'size': e.size,
            'file': e
          }
          this.uploadArtworkReady = true
        } else {
          this.uploadProgress = 0
          this.uploadArtwork = {},
          this.uploadArtworkReady = false
        }
      },
      uploadFileArtwork: function() {
        const uploadTask = storage.ref().child(this.newCd._storage_folder+'/'+this.uploadArtwork.name).put(this.uploadArtwork.file);
        uploadTask.on('state_changed', snapshot=> {
          this.isUpLoaded = false
          this.uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        }, error=>{ alert(error.message) }, () => { 
            this.uploadProgress = 100
            this.isUpLoaded = true
            uploadTask.snapshot.ref.getDownloadURL().then((url)=>{
              this.newCd.artwork = {
                'name': this.uploadArtwork.name,
                'size': this.uploadArtwork.size,
                'url': url
              }
              this.uploadProgress = 0
              this.uploadArtwork = {},
              this.uploadArtworkReady = false
            });
          }
        );
      },
      removeFileArtwork: function() {
        const deleteTask = storage.ref().child(this.newCd._storage_folder+'/'+this.newCd.artwork.name);
        deleteTask.delete().then(() => {
          this.newCd.artwork = {}
          //this.$refs.inputFileArtwork.$el.click()
        }).catch((error) => {
          window.console.log(error);
        });
      },   
      // UPLOAD-REMOVE TRANSCRIPT         
      onFilePickedTranscript(e) {
        if (e !== undefined) {
          this.uploadTranscript = {
            'name': e.name,
            'size': e.size,
            'file': e
          }
          this.uploadTranscriptReady = true
        } else {
          this.uploadProgress = 0
          this.uploadTranscript = {},
          this.uploadTranscriptReady = false
        }
      },
      uploadFileTranscript: function() {
        const uploadTask = storage.ref().child(this.newCd._storage_folder+'/'+this.uploadTranscript.name).put(this.uploadTranscript.file);
        uploadTask.on('state_changed', snapshot=> {
          this.isUpLoaded = false
          this.uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        }, error=>{ alert(error.message) }, () => { 
            this.uploadProgress = 100
            this.isUpLoaded = true
            uploadTask.snapshot.ref.getDownloadURL().then((url)=>{
              this.newCd.transcript = {
                'name': this.uploadTranscript.name,
                'size': this.uploadTranscript.size,
                'url': url
              }
              this.uploadProgress = 0
              this.uploadTranscript = {},
              this.uploadTranscriptReady = false 
            });
          }
        );
      },
      removeFileTranscript: function() {
        const deleteTask = storage.ref().child(this.newCd._storage_folder+'/'+this.newCd.transcript.name);
        deleteTask.delete().then(() => {
          this.newCd.transcript = {}
          //this.$refs.inputFileTranscript.$el.click()
        }).catch((error) => {
          window.console.log(error);
        });
      },   
      // UPLOAD-REMOVE ZIP                
      onFilePickedZip(e) {
        if (e !== undefined) {
          this.uploadZip = {
            'name': e.name,
            'size': e.size,
            'file': e
          }
          this.uploadZipReady = true
        } else {
          this.uploadProgress = 0
          this.uploadZip = {},
          this.uploadZipReady = false
        }
      },      
      uploadFileZip: function() {
        const uploadTask = storage.ref().child(this.newCd._storage_folder+'/'+this.uploadZip.name).put(this.uploadZip.file);
        uploadTask.on('state_changed', snapshot=> {
          this.isUpLoaded = false
          this.uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        }, error=>{ alert(error.message) }, () => { 
            this.uploadProgress = 100
            this.isUpLoaded = true
            uploadTask.snapshot.ref.getDownloadURL().then((url)=>{
              this.newCd.zip = {
                'name': this.uploadZip.name,
                'size': this.uploadZip.size,
                'url': url
              }
              this.uploadProgress = 0
              this.uploadZip = {},
              this.uploadZipReady = false 
            });
          }
        );
      },
      removeFileZip: function() {
        const deleteTask = storage.ref().child(this.newCd._storage_folder+'/'+this.newCd.zip.name);
        deleteTask.delete().then(() => {
          this.newCd.zip = {}
          //this.$refs.inputFileZip.$el.click()
        }).catch((error) => {
          window.console.log(error);
        });
      },
      // UPLOAD_REMOVE TRACKS
      onFilePickedTracks(e) {
        if (e !== undefined) { 
          const tracks = [];
          e.forEach(function (item) {
            //window.console.log(item, item.name);
            let track = {
                'title': item.name,
                'size': item.size,
                'file': item
            };
            tracks.push(track)
          });
          this.uploadTracks = tracks
          this.uploadTracksReady = true
        }
      },
      uploadFilesTracks: function() {
        this.uploadTracks.forEach(function(track){
          const uploadTask = storage.ref().child(this.newCd._storage_folder+'/'+track.title).put(track.file);          
          uploadTask.on('state_changed', snapshot=> {
            this.isUpLoaded = false
            this.uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
          }, error=>{ alert(error.message) }, () => { 
              this.uploadProgress = 100
              this.isUpLoaded = true
              uploadTask.snapshot.ref.getDownloadURL().then((url)=>{
                let setTrack = {
                    'fileName': track.title,
                    'size': track.size,
                    'title': track.title.slice(3).replace('.mp3', ''),
                    'url': url
                };
                this.newCd.tracks.push(setTrack)
                this.uploadProgress = 0
                this.uploadTracks = []
                this.uploadTracksReady = false
              });
            }
          );
        }, this);        
      },
      slugify: function(string) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')
        return string.toString().toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(/&/g, '-and-') // Replace & with 'and'
          .replace(/[^\w-]+/g, '') // Remove all non-word characters
          .replace(/--+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, '') // Trim - from end of text
      }                     
    }
};
</script>

<style lang="scss">
.v-application .blockquote a {
  color: #000;
  &:hover {
    opacity: .6;
    text-decoration: none; 
  }
}
.uploading-block {
  background-color:rgba(0,0,0,.6);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #ab4538;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
}
.ck-editor__editable {
  overflow: hidden;
  width: 100%;
  min-height: 150px;
}

.v-list:not(.admin-view) .v-list-item.cd-published-false {
  display: none;
}
.v-list.admin-view .v-list-item.cd-published-false {
  opacity: .4;
}
</style>